import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import ResetStep1 from "../../components/reset/ResetStep1";
import ResetStep2 from "../../components/reset/ResetStep2";
import { resetBeginReset } from "../../redux/actions/auth/reset";

import "./ResetPassword.css";
import { useTranslation } from "react-i18next";

export default function ResetPassword() {

    const {t} = useTranslation("login")
    const [step, setStep] = useState(1);
    const [question, setQuestion] = useState("");
    const [userProfileId, setUserProfileId] = useState("");
    const [email, setEmail] = useState("");

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const optionArray = {
        1: t('3-what-childhood-nick'),
        2: t('3-what-childhood-friend'),
        3: t('3-city-job-q'),
        4: t('3-what-spouse')
    };

    const showQuestion = (question: string, questionId: number, userProfileId: string, email: string) => {
        setStep(2);
        if([1,2,3,4].includes(questionId)) {
            setQuestion(optionArray[questionId] as string)
        } else {
            setQuestion(question);
        }
        
        setUserProfileId(userProfileId);
        setEmail(email);
    }


    const [resetted, setResetted] = useState(false)
    const [canceled, setCanceled] = useState(false);

    const cancel = () => {
        setCanceled(true);
    }

    if (canceled) {

        if (resetted) {
            navigate("/auth/home/reg-user");
        } else {
            setStep(1);
            setQuestion("");
            setUserProfileId("");
            setResetted(true);
            dispatch(resetBeginReset());
        }
    }

    return (
        <>
            <div className="reset-top">
                {step === 1 && <ResetStep1 nextStep={showQuestion} cancel={cancel} />}
                {step === 2 && <ResetStep2 question={question} userProfileId={userProfileId} email={email} cancel={cancel} />}
            </div>
        </>
    )
}
